import {Component} from '@angular/core';
import {AuthUserService} from "../../@shared/services/auth/auth-user.service";
import {environment} from "../../../environments/environment";
import {INavLink} from "../../@core/interfaces/nav-link.interface";
import {NOTIFICATIONS_ROLES} from "../../@shared/constants/vip-access";


const CSGOFAST_LINKS: INavLink[] = [
  // {
  //   link: 'user/find',
  //   icon: 'people',
  //   label: 'Users',
  //   roles: ['main_admin', 'main_owner', 'main_moderator', 'main_promoter']
  // },
  {
    link: 'stats',
    icon: 'list',
    label: 'Statistic',
    roles: ['main_admin', 'main_owner', 'main_moderator', 'main_promoter']
  },
  {
    link: 'moderation',
    icon: 'fact_check',
    label: 'Moderation',
    roles: ['main_admin', 'main_owner', 'main_moderator', 'main_promoter']
  },
  {
    link: 'promo',
    icon: 'confirmation_number',
    label: 'Promo / Ref',
    roles: ['main_admin', 'main_owner', 'main_promoter']
  },
  {
    link: 'bot-settings',
    icon: 'smart_toy',
    label: 'Bot settings',
    roles: ['main_admin', 'main_owner', 'main_moderator', 'main_promoter']
  },
  {
    link: 'domains',
    icon: 'public',
    label: 'Domains',
    roles: ['main_owner']
  },
  {
    link: 'offerwall',
    icon: 'request_quote',
    label: 'Offer wall',
    roles: ['main_admin', 'main_owner', 'main_moderator', 'main_promoter']
  },
  {
    link: 'notifications',
    icon: 'notifications',
    label: 'Notifications',
    roles: [...NOTIFICATIONS_ROLES]
  },
  {
    link: 'trustpilot',
    icon: 'rate_review',
    label: 'Trustpilot',
    roles: [...NOTIFICATIONS_ROLES]
  },
  {
    link: 'surveys',
    icon: 'quiz',
    label: 'Опросы',
    roles: [...NOTIFICATIONS_ROLES]
  },
  {
    link: 'customization',
    icon: 'style',
    label: 'Кастомизация',
    roles: ['main_admin', 'main_owner', 'main_moderator', 'main_promoter']
  }
]
const HLTV_LINKS: INavLink[] = [
  // {
  //   link: 'user/find',
  //   icon: 'people',
  //   label: 'Users',
  //   roles: ['main_admin', 'main_owner', 'main_moderator', 'main_promoter']
  // },
  {
    link: 'payments',
    icon: 'payments',
    label: 'Payments',
    roles: ['main_admin', 'main_owner', 'main_promoter']
  },
  {
    link: 'stats',
    icon: 'list',
    label: 'Statistic',
    roles: ['main_admin', 'main_owner', 'main_moderator', 'main_promoter']
  },
  {
    link: 'promo',
    icon: 'confirmation_number',
    label: 'Promo / Ref',
    roles: ['main_admin', 'main_owner', 'main_moderator', 'main_promoter']
  },
  {
    link: 'bot-settings',
    icon: 'smart_toy',
    label: 'Bot settings',
    roles: ['main_owner']
  },
  {
    link: 'domains',
    icon: 'public',
    label: 'Domains',
    roles: ['main_owner']
  },
  {
    link: 'moderation',
    icon: 'fact_check',
    label: 'Moderation',
    roles: ['main_admin', 'main_owner', 'main_moderator', 'main_promoter']
  },
]

@Component({
  selector: 'app-start-page',
  templateUrl: './start-page.component.html',
  styleUrls: ['./start-page.component.scss']
})
export class StartPageComponent {
  public user$ = this.authUserService.user$;
  public navLink: INavLink[];

  constructor(private authUserService: AuthUserService) {
    this.navLink = environment.projectName === 'HLTV'
      ? HLTV_LINKS
      : CSGOFAST_LINKS
  }

  public hideTab(user: any, roles: string[]): boolean {
    return user.roles.some((role: string) => roles.includes(role))
  }
}
